import {Dialog, DialogContent, DialogTitle, Typography} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

function MenuItemDialog(props) {
  const {isOpen, close, title, content, img} = props

  function renderParagraph(paragraph, pIx) {
    const lineArray = paragraph.split('\n')

    return (
      <div key={pIx}>
        {lineArray.map((l, lIx) => {
          return renderLine(l, pIx, lIx)
        })}
        <p/>
      </div>
    )
  }

  function renderLine(line, pIx, lIx) {
    return (
        <Typography key={`${pIx}.${lIx}`} sx={{fontSize: 12, marginRight: 2}}>
          {line}
        </Typography>
    )
  }

  if (content === undefined) {
    return null
  }

  const paragraphPattern = /\n\n/
  const paragraphArray = content.split(paragraphPattern)

  return (
    <Dialog open={isOpen} onClose={close}>
      <DialogTitle sx={{fontSize: 14}}>
          {title}
      </DialogTitle>
      <IconButton
              aria-label="close"
              onClick={close}
              sx={(theme) => ({
                position: 'absolute',
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
      >
        <CloseIcon />
      </IconButton>

    <DialogContent sx={{marginTop: -2, marginBottom: -2}}>
      {img !== undefined ? (
              <img src={img} alt={''} width={'45%'}/>
      ) : null}
      {paragraphArray.map((p, ix) => {
        return renderParagraph(p, ix)
      })}
    </DialogContent>
  </Dialog>
  )
}

export {MenuItemDialog}